import React, { useRef, useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import styled from "@emotion/styled";

export const StyledErrorMessage = styled("div")({
  color: "red",
  fontSize: "14px",
  width:"fit-content",
  marginTop: "5px",
});

const StyledPhoneInputContainer = styled("div")`
  position: relative;
  width: 100%;
 display: flex;
    flex-direction: column;
  .contact-inputField {
    width: ${(props) => props.width || "100%"};
    height: ${(props) => props.height || "auto"};
  }

  .react-tel-input .form-control {
    width: 100%;
    height: 100%;
    background-color: transparent;
    border-radius: 12px;
    ::placeholder {
      opacity: ${(props) => (props.isFocused || props.hasValue ? "0" : "1")};
      transition: opacity 0.3s;
    }
    border: 1px solid var(--border__color);
  }

   .react-tel-input .country-list {
    width: ${(props) => props.countryListWidth || "340px"};
    display:flex;
    flex-direction:column;
    align-items:baseline;
    border-radius: 12px;
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 12px;
      background-color: #e6f1f5;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 12px;
      background-color: #1b52a729;
    }
    &::-webkit-scrollbar-thumb:hover {
      background-color:  #1b52a742

;
    }
    &::-webkit-scrollbar-thumb:active {
      background-color: #1b52a740;
    }
`;

const StyledLabel = styled.label`
  font-size: 16px;
  font-weight: 600;
  width: fit-content;
  margin-bottom: 15px;
  className: "textfield-label";
`;

export const StyledAsterisk = styled.span`
  color: red;
  margin-left: ${(props) =>
    props.isFocused || props.hasValue ? "1px" : "5px"};
  position: absolute;
  top: ${(props) => (props.isFocused || props.hasValue ? "-2px" : "0px")};
  display: ${(props) =>
    props.isFocused || !props.hasCountry ? "inline" : "none"};
`;

const PhoneNumberInput = (props) => {
  const {
    value,
    onChange,
    onBlur,
    error,
    touched,
    width,
    height,
    marginBottom,
    placeholder,
    label,
    required = false,
    backgroundColor = "white",
    labelColor = "black",
    labelStyle = {},
    country,
    phoneContainerStyle = {},
    countryListWidth,
  } = props || {};

  const [isFocused, setIsFocused] = useState(false);

  const handlePhoneChange = (phone, countryData) => {
    if (onChange) {
      onChange(phone, countryData);
    }
  };
  const inputWrapperRef = useRef(null);
  const [dynamicWidth, setDynamicWidth] = useState("auto");

  useEffect(() => {
    if (inputWrapperRef.current) {
      const width = inputWrapperRef.current.offsetWidth;
      setDynamicWidth(`${width}px`);
    }
    const handleResize = () => {
      if (inputWrapperRef.current) {
        const width = inputWrapperRef.current.offsetWidth;
        setDynamicWidth(`${width}px`);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleFocus = () => setIsFocused(true);
  const handleBlur = (e) => {
    setIsFocused(false);
    if (onBlur) {
      onBlur(e);
    }
  };

  const labelWithAsterisk = required ? `${label} ` : label;

  return (
    <StyledPhoneInputContainer
      width={width}
      height={height}
      marginBottom={marginBottom}
      isFocused={isFocused}
      hasValue={value && value.length > 0}
      hasCountry={!!country}
      style={phoneContainerStyle}
      countryListWidth={countryListWidth}
    >
      {label && (
        <label className="textfield-label" style={{ marginBottom: "15px", ...labelStyle }}>
          {labelWithAsterisk}
          {required && (
            <StyledAsterisk
              isFocused={isFocused}
              hasValue={value !== ""}
              hasCountry={!!country}
            >
              *
            </StyledAsterisk>
          )}
        </label>
      )}
      <PhoneInput
        country={country}
        value={value}
        onChange={handlePhoneChange}
        onBlur={handleBlur}
        onFocus={handleFocus}
        inputProps={{
          name: "contact",
          required,
          autoFocus: false,
          placeholder: placeholder,
        }}
        specialLabel=""
        containerClass="contact-inputField"
        inputClass={touched && error ? "error" : ""}
         prefix="+"
      />

      {touched && error && (
        <StyledErrorMessage className="error-message-createaccount">
          {error}
        </StyledErrorMessage>
      )}
    </StyledPhoneInputContainer>
  );
};

export default PhoneNumberInput;
